import { t } from "../../translations";

let LOCALIZATOR = {
  toolbar: {
    searchPlaceholder: t("localizator.search"),
    searchTooltip: t("localizator.search"),
    exportTitle: t("localizator.exportRecords"),
  },
  pagination: {
    labelRowsPerPage: t("localizator.hello"),
    labelRowsSelect: t("localizator.records"),
  },
  body: {
    deleteTooltip: t("localizator.delete"),
    addTooltip: t("localizator.add"),
    editTooltip: t("localizator.edit"),
    emptyDataSourceMessage: t("localizator.NoRecordsFound"),
    editRow: {
      deleteText: t("localizator.deleteTheRecord"),
      saveTooltip: t("localizator.save"),
      cancelTooltip: t("localizator.cancel"),
    },
  },
  grouping: {
    groupedBy: t("localizator.groupedby"),
    placeholder: t("localizator.dragToGroup"),
  },
};

let LOCALIZATOR_PARTIDAS = {
  toolbar: {
    searchPlaceholder: t("localizator.search"),
    searchTooltip: t("localizator.search"),
    exportTitle: t("localizator.exportRecords"),
  },
  pagination: {
    labelRowsPerPage: t("localizator.hello"),
    labelRowsSelect: t("localizator.records"),
  },
  body: {
    deleteTooltip: t("localizator.delete"),
    addTooltip: t("localizator.add"),
    editTooltip: t("localizator.edit"),
    emptyDataSourceMessage: t("localizator.noAssociatedDocument"),
    editRow: {
      deleteText: t("localizator.deleteTheRecord"),
      saveTooltip: t("localizator.save"),
      cancelTooltip: t("localizator.cancel"),
    },
  },
  grouping: {
    groupedBy: t("localizator.groupedby"),
    placeholder: t("localizator.dragToGroup"),
  },
};

export { LOCALIZATOR, LOCALIZATOR_PARTIDAS };
